/* MODHAX TOP — v3 (S1 SELECT / S2 ABOUT US / S3 SECRET) */
(function () {
  'use strict';
  if (window.__mxLoaded) return;
  window.__mxLoaded = true;

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var reduce = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var headerEl = null;

  function measure() {
    var h = headerEl || document.querySelector('.mhx-header');
    document.documentElement.style.setProperty('--mx-head', Math.round(h ? h.getBoundingClientRect().height : 0) + 'px');
    var f = document.querySelector('.modhax-footer');
    document.documentElement.style.setProperty('--mx-foot', Math.round(f ? f.getBoundingClientRect().height : 0) + 'px');
  }

  function initStickyHeader() {
    var hdr = document.querySelector('.mhx-header');
    if (!hdr) return;
    headerEl = hdr;
    var wrap = hdr.closest('.shopify-section') || hdr;
    if (wrap.dataset.mxHeadReady === '1') return;
    wrap.dataset.mxHeadReady = '1';
    wrap.classList.add('mx-stickyhead');
    if (window.ResizeObserver) new ResizeObserver(measure).observe(hdr);
    var footer = document.querySelector('.modhax-footer');
    if (!footer) return;
    if (window.ResizeObserver) new ResizeObserver(measure).observe(footer);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { wrap.classList.toggle('mx-head-hidden', e.isIntersecting); });
    }, { threshold: 0.01 });
    io.observe(footer);
  }

  function initNav() {
    if (document.querySelector('.mx-nav')) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('.mx-sec'));
    if (secs.length < 2) return;
    var nav = document.createElement('nav');
    nav.className = 'mx-nav';
    secs.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'section ' + (i + 1));
      b.addEventListener('click', function () { s.scrollIntoView({ behavior: 'smooth' }); });
      nav.appendChild(b);
    });
    document.body.appendChild(nav);
    var btns = nav.querySelectorAll('button');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = secs.indexOf(e.target);
        btns.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }, { threshold: 0.55 });
    secs.forEach(function (s) { io.observe(s); });
  }

  function initSelect(root) {
    if (root.dataset.mxReady === '1') return;
    root.dataset.mxReady = '1';

    var hero = root.querySelector('.mx-hero');
    var rail = root.querySelector('.mx-rail');
    var view = root.querySelector('.mx-railview');
    if (!hero || !rail || !view) return;
    var nameBar = root.querySelector('.mx-namebar');
    var detailBtn = root.querySelector('.mx-detail-btn');
    var modal = root.querySelector('.mx-modal');

    function metrics() {
      var c = rail.children;
      if (!c.length) return null;
      var cw = c[0].getBoundingClientRect().width;
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 16;
      return { cw: cw, gap: gap, step: cw + gap };
    }
    function layout() {
      var m = metrics();
      if (!m || !m.cw) return;
      var n = Math.min(isMobile() ? 3 : 5, rail.children.length);
      var cs = getComputedStyle(view);
      var bl = parseFloat(cs.borderLeftWidth) || 0;
      var br = parseFloat(cs.borderRightWidth) || 0;
      view.style.width = (Math.ceil(n * m.cw + (n - 1) * m.gap) + 2 + bl + br) + 'px';
    }

    var animating = false;
    function rotate(dir) {
      if (animating) return;
      var cards = rail.children;
      if (cards.length < 2) return;
      var m = metrics();
      if (!m) return;
      if (reduce()) {
        if (dir > 0) rail.appendChild(cards[0]);
        else rail.insertBefore(cards[cards.length - 1], cards[0]);
        return;
      }
      animating = true;
      var D = 280;
      if (dir > 0) {
        rail.style.transition = 'transform ' + D + 'ms ease';
        rail.style.transform = 'translateX(-' + m.step + 'px)';
        setTimeout(function () {
          rail.style.transition = 'none';
          rail.style.transform = 'none';
          rail.appendChild(rail.children[0]);
          animating = false;
        }, D + 10);
      } else {
        rail.insertBefore(cards[cards.length - 1], cards[0]);
        rail.style.transition = 'none';
        rail.style.transform = 'translateX(-' + m.step + 'px)';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            rail.style.transition = 'transform ' + D + 'ms ease';
            rail.style.transform = 'none';
            setTimeout(function () { animating = false; }, D + 10);
          });
        });
      }
    }

    function showHero(key) {
      var imgs = hero.querySelectorAll('img');
      var found = false;
      imgs.forEach(function (im) { if (im.getAttribute('data-key') === key) found = true; });
      if (!found) key = key.replace(/-sp$/, '');
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-key') === key); });
    }

    function colorize(card, on) {
      if (!card) return;
      var edge = card.getAttribute('data-edge');
      var inner = card.getAttribute('data-inner');
      var nm = card.querySelector('.mx-name');
      if (on) {
        if (inner) card.style.background = inner;
        if (edge) card.style.borderColor = edge;
        if (nm && edge) { nm.style.background = edge; nm.style.color = '#fff'; }
      } else {
        card.style.background = '';
        card.style.borderColor = '';
        if (nm) { nm.style.background = ''; nm.style.color = ''; }
      }
    }

    function currentActive() { return rail.querySelector('.mx-card.is-active'); }

    function activate(card) {
      var prevActive = currentActive();
      if (prevActive && prevActive !== card) { prevActive.classList.remove('is-active'); colorize(prevActive, false); }
      card.classList.add('is-active');
      colorize(card, true);
      root.classList.add('is-selected');
      var key = card.getAttribute('data-key');
      showHero(isMobile() ? key + '-sp' : key);
      if (nameBar) {
        nameBar.textContent = card.getAttribute('data-name') || '';
        nameBar.classList.add('is-on');
        var edge = card.getAttribute('data-edge') || '#333';
        nameBar.style.background = 'linear-gradient(90deg,#3d0a0a 0%,' + edge + ' 50%,#3d0a0a 100%)';
      }
      if (detailBtn) { detailBtn.classList.add('is-on'); detailBtn.setAttribute('data-for', key); }
    }

    function reset() {
      var a = currentActive();
      if (a) { a.classList.remove('is-active'); colorize(a, false); }
      root.classList.remove('is-selected');
      showHero(isMobile() ? 'default-sp' : 'default');
      if (nameBar) nameBar.classList.remove('is-on');
      if (detailBtn) detailBtn.classList.remove('is-on');
    }

    rail.querySelectorAll('.mx-card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (animating) return;
        var href = card.getAttribute('data-href');
        if (card.classList.contains('is-active')) { if (href) window.location.href = href; }
        else { activate(card); }
      });
    });

    var prev = root.querySelector('.mx-arrow--prev');
    var next = root.querySelector('.mx-arrow--next');
    if (prev) prev.addEventListener('click', function () { rotate(-1); });
    if (next) next.addEventListener('click', function () { rotate(1); });

    var sx = null;
    view.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    view.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) rotate(dx < 0 ? 1 : -1);
      sx = null;
    }, { passive: true });

    if (detailBtn && modal) {
      detailBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var key = detailBtn.getAttribute('data-for');
        modal.querySelectorAll('[data-key]').forEach(function (n) { n.hidden = n.getAttribute('data-key') !== key; });
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      modal.addEventListener('click', function (e) {
        if (e.target.matches('.mx-modal__dim, .mx-modal__close')) {
          modal.hidden = true; document.body.style.overflow = '';
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ''; }
      });
    }

    window.addEventListener('resize', function () { measure(); layout(); reset(); });
    window.addEventListener('load', function () { measure(); layout(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); layout(); });
    layout();
    reset();
  }

  function initAbout(root) {
    if (root.dataset.mxReady === '1') return;
    root.dataset.mxReady = '1';
    var wrap = root.querySelector('.mx-chapters');
    var dots = root.querySelectorAll('.mx-dots i');
    if (!wrap) return;

    function sync() {
      var i = Math.round(wrap.scrollLeft / wrap.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }
    function go(dir) {
      var i = Math.round(wrap.scrollLeft / wrap.clientWidth) + dir;
      var n = wrap.children.length;
      if (i < 0) i = n - 1;
      if (i > n - 1) i = 0;
      wrap.scrollTo({ left: i * wrap.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
    }
    wrap.addEventListener('scroll', sync, { passive: true });
    var p = root.querySelector('.mx-arrow--prev');
    var n2 = root.querySelector('.mx-arrow--next');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n2) n2.addEventListener('click', function () { go(1); });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        wrap.scrollTo({ left: j * wrap.clientWidth, behavior: reduce() ? 'auto' : 'smooth' });
      });
    });
    wrap.scrollLeft = 0;
    sync();
  }

  function targetOf(a) {
    var href = (a.getAttribute('href') || '').toLowerCase();
    var txt = (a.textContent || '').toUpperCase().replace(/[^A-Z]/g, '');
    var i = href.indexOf('#');
    if (i > -1) {
      var h = href.slice(i);
      if (h.indexOf('secret') > -1) return 'secret';
      if (h.indexOf('about') > -1) return 'about';
    }
    if (txt === 'SECRET' || txt === 'SPELL') return 'secret';
    if (txt === 'ABOUTUS' || txt === 'ABOUT') return 'about';
    return null;
  }
  function sectionFor(t) {
    return document.querySelector(t === 'about' ? '.mx-sec--about' : '.mx-sec--secret');
  }
  function closeDrawer() {
    var d = document.getElementById('mhxDrawer');
    if (d) d.classList.remove('is-open');
    var s = document.getElementById('mhxSearchDrawer');
    if (s) s.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initAnchors() {
    var sel = '.mhx-header a, .mhx-drawer a, .modhax-footer a';
    document.querySelectorAll(sel).forEach(function (a) {
      if (a.dataset.mxAnchor === '1') return;
      var t = targetOf(a);
      if (!t) return;
      a.dataset.mxAnchor = '1';
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        var sec = sectionFor(t);
        if (!sec) { e.preventDefault(); window.location.href = '/#' + t; return; }
        e.preventDefault();
        closeDrawer();
        sec.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth' });
        if (window.history && history.replaceState) history.replaceState(null, '', '#' + t);
      });
    });
  }
  function fromHash() {
    var h = (location.hash || '').toLowerCase();
    if (!h) return;
    var t = h.indexOf('secret') > -1 ? 'secret' : (h.indexOf('about') > -1 ? 'about' : null);
    if (!t) return;
    setTimeout(function () {
      var sec = sectionFor(t);
      if (sec) sec.scrollIntoView({ behavior: 'auto' });
    }, 200);
  }

  function boot() {
    initStickyHeader();
    measure();
    document.querySelectorAll('[data-mx-select]').forEach(initSelect);
    document.querySelectorAll('[data-mx-about]').forEach(initAbout);
    initNav();
    initAnchors();
    fromHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('load', function () { measure(); initAnchors(); });
  window.addEventListener('hashchange', fromHash);

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    initStickyHeader();
    measure();
    t.querySelectorAll('[data-mx-select]').forEach(initSelect);
    t.querySelectorAll('[data-mx-about]').forEach(initAbout);
    initAnchors();
  });
})();
